// @flow

import { createSelector } from 'reselect';
import { compact, flatten, get, map, toLower } from 'lodash/fp';

import t from '../../utils/translate';

const getSportChannels = map(cat => ({
  id: cat.id,
  name: cat.name,
  icon: `icon-sport-${cat.icon}`,
  slug: toLower(cat.slug || cat.name.replace(/[- ]/g, '_'))
}));
const sportChannelsSelector = createSelector(
  get('chat.channels'),
  getSportChannels
);

function getDefaultChannels() {
  return compact([
    {
      id: 'general',
      name: 'General',
      icon: 'icon_menu_faqs',
      slug: 'general'
    }
  ]);
}

const defaultChannelsSelector = createSelector(
  get('settings.feedbackUri'),
  getDefaultChannels
);

const challengeChannelsSelector = createSelector(
  get('challenge.id'),
  challengeId =>
    challengeId
      ? [
          {
            id: 'challenge',
            name: t('Challenge'),
            icon: 'icon-challenge-outline',
            slug: challengeId
          }
        ]
      : []
);

function getExtraChannels(extraChannels) {
  return extraChannels || [];
}

const extraChannelsSelector = createSelector(
  get('settings.chatExtraChannels'),
  getExtraChannels
);

function getAllChannels(...groups) {
  return flatten([...groups]);
}

const chatChannelsSelector = createSelector(
  defaultChannelsSelector,
  extraChannelsSelector,
  challengeChannelsSelector,
  sportChannelsSelector,
  getAllChannels
);

export default chatChannelsSelector;
